export default __webpack_public_path__ + "static/media/1.dfb68ba0.jpg";